import React from 'react'

function CategoryVideo(props) {
  const { filteredTags, searchInput, setSearchInput, handleTagCheckboxChange, previewVideo } = props
  return (
    <>
      <div className='mt-3'>
        <label className='mb-2 d-block'>Category:</label>

        <div
          className='border border-dark p-3 rounded'
          style={{
            maxHeight: '400px',
            overflowY: 'auto',
            display: 'grid',
            maxWidth: '300px',
            gap: '1rem',
          }}
        >
          <input
            type='text'
            placeholder='Search Category...'
            className='form-control mb-3'
            onChange={e => setSearchInput(e.target.value)}
            value={searchInput}
          />
          {filteredTags.map((tag, index) => (
            <div key={index} className='form-check'>
              <input
                type='checkbox'
                id={`tag-${index}`}
                className='form-check-input'
                onChange={e => handleTagCheckboxChange(tag.tagURL, e.target.checked)}
                checked={previewVideo.galleryTags.includes(tag.tagURL)}
              />
              <label htmlFor={`tag-${index}`} className='form-check-label ml-2'>
                {tag.tagURL}
              </label>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default CategoryVideo
